import { gql } from "@apollo/client";

export const GET_ACCESS_TOKEN = gql`
  query getAccessToken($uuid: String!) {
    getAccessToken(uuid: $uuid)
  }
`;
